import { ActivatedRoute } from '@angular/router';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, zip } from 'rxjs';
import { tap } from 'rxjs/operators';

import { BasePage } from '../../base.page';
import {
    ContractInterface,
    ContractSignatureType,
    GetContractSignatoriesUseCase,
    GetContractUseCase,
    OrderClientInterface,
    SignTransferUseCase,
    TransferInterface,
} from '../../../../core';
import { ContributionPage } from '../contribution.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { Id } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    templateUrl: './contribution-sign.page.html',
    styleUrls: ['./contribution-sign.page.scss'],
})
export class ContributionSignPage extends BasePage implements AfterViewInit, OnDestroy, OnInit {
    private backSubscription: Subscription;

    public changed = false;
    public contract: ContractInterface;
    public participants: OrderClientInterface[] = [];
    public transfer: TransferInterface;

    public isClientPortal = environment.portalClient;

    constructor(
        contributionPage: ContributionPage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getContractSignatoriesUseCase: GetContractSignatoriesUseCase,
        private localStorage: LocalStorage,
        private route: ActivatedRoute,
        private signTransferUseCase: SignTransferUseCase
    ) {
        super(parentEvents);
        contributionPage.showBackButton();
        this.backSubscription = contributionPage.back.subscribe(() => {
            window.history.back();
        });
    }

    get signedBy(): 'all' | 'one' {
        return (this.contract && this.contract.signatureType === ContractSignatureType.JOINT) || this.changed ? 'all' : 'one';
    }

    ngOnInit(): void {
        this.getContribution();
    }

    private getContribution(): void {
        this.route.data.subscribe((data) => {
            this.changed = data.changed || false;
            this.transfer = data.transfer;

            this.getSignatories();
        });
    }

    private getSignatories(): void {
        let signatoriesParams = {};
        if (!this.changed) {
            signatoriesParams = {
                clientCode: new Id(this.localStorage.clientCode),
            };
        }

        zip(
            this.getContractUseCase.bind().pipe(
                tap((transaction) =>
                    transaction.fold(
                        (contract) => (this.contract = contract),
                        (throwable) =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: throwable.message },
                            })
                    )
                )
            ),
            this.getContractSignatoriesUseCase.bind(signatoriesParams).pipe(
                tap((transaction) =>
                    transaction.fold(
                        (signatories) => {
                            this.participants = signatories;
                            this.participants.forEach((participant) => (participant.signatureType = undefined));
                        },
                        () =>
                            this.dialog.open(ErrorDialog, {
                                data: { text: 'error.selected-product-not-signatories' },
                            })
                    )
                )
            )
        ).subscribe();
    }

    ngOnDestroy() {
        this.backSubscription.unsubscribe();
    }

    onSubmit() {
        this.signTransferUseCase
            .bind({
                signatories: this.participants.filter((participant) => !!participant.signatureType),
                transfer: this.transfer,
            })
            .subscribe((transaction) => {
                transaction.fold(
                    () => this.parentEvents.cancel(),
                    (throwable) =>
                        this.dialog.open(ErrorDialog, {
                            data: { text: throwable.message },
                        })
                );
            });
    }
}
